import(/* webpackMode: "eager" */ "/vercel/path0/src/app/restricted/page.js");
